export const FNLONDON_COLORS = Object.freeze([
  '#F37056', // orange
  '#FDB456', // yellow
  '#5FAFCB', // blue
  '#C8CCCD', // light grey
  '#A7AFB3', // grey
  '#70808C', // medium grey
  '#4D6172', // dark grey
  '#203140', // blue black
  // oranges
  '#994736', // dark orange
  '#CC5E48', // medium orange //
  // '#F37056', // orange
  '#F39886', // light orange
  '#F3C0B6', // white orange
  // yellows
  '#A37437', // yellow
  '#D69849', // yellow
  '#FDCA89', // light yellow
  '#FDE0BB', // white yellow
  // blues
  '#305866', // dark blue
  '#488499', // medium blue
  // '#5FAFCB', // blue
  '#88BACB', // light blue
  '#B1C4CB', // white blue
  'rgba(0, 0, 0, 0)', // transparent
  // pen
  '#1f3771', // navy
  '#99a8b5', // light blue/grey
  '#4d6171', // dark blue/grey
  '#cbb75f', // gold
]);

const FNLONDON_THEME = Object.freeze({
  name: 'Financial News',
  theme: Object.freeze([
    FNLONDON_COLORS[0],
    FNLONDON_COLORS[1],
    FNLONDON_COLORS[2],
    FNLONDON_COLORS[3],
    FNLONDON_COLORS[4],
    FNLONDON_COLORS[5],
    FNLONDON_COLORS[6],
    FNLONDON_COLORS[7],
  ]),
});

const PEN_THEME = Object.freeze({
  name: 'PEN',
  theme: Object.freeze([
    FNLONDON_COLORS[21],
    FNLONDON_COLORS[2],
    FNLONDON_COLORS[22],
    FNLONDON_COLORS[23],
    FNLONDON_COLORS[24],
  ]),
});

const FNLONDON_GRAY_THEME = Object.freeze({
  name: 'Gray theme',
  theme: Object.freeze([FNLONDON_COLORS[6], '#70808c', '#a7afb3', '#c8cccd', '#e7e1da ']),
});

const FNLONDON_ORANGE_THEME = Object.freeze({
  name: 'Orange theme',
  theme: Object.freeze([FNLONDON_COLORS[0], '#fdb456', '#fde0bd', '#e7e1da', '#e7e1da ']),
});

export const FNLONDON_COLOR_THEMES = Object.freeze({
  fnlondon: FNLONDON_THEME,
  pen: PEN_THEME,
  fnlondon_gray: FNLONDON_GRAY_THEME,
  fnlondon_orange: FNLONDON_ORANGE_THEME,
});

export const FNLONDON_PIE_THEME = Object.freeze([
  ...FNLONDON_GRAY_THEME.theme,
  ...FNLONDON_ORANGE_THEME.theme,
]);

export const FNLONDON_PLOT_LINE_COLORS = Object.freeze([FNLONDON_COLORS[7], FNLONDON_COLORS[3]]);
